/**
 * Shown for the one round-trip it takes to answer "is this browser signed in?".
 * Deliberately quiet: no spinner, no skeleton flash — a line of mono type in the
 * page's own margins, so a fast refresh looks like nothing happened at all.
 */
export default function AuthPending() {
  return (
    <section className="page-gutter mx-auto max-w-(--container-page) py-32">
      <p className="label text-ink-60" role="status">
        One moment&hellip;
      </p>
    </section>
  );
}
